<template>
  <v-data-table
    :headers="auditRecommendationListHeaders"
    :hide-default-footer="recommendations.length <= 10"
    :items="recommendations"
    class="mb-3"
    color="red"
    density="compact"
    item-value="id"
    rounded="pill">
    <template #item.recommendationStatus="{ item }">
      <v-chip color="grey-darken-3" density="compact" rounded="pill">
        <span class="font-weight-bold">{{ item.status?.name || '--- ' }}</span>
      </v-chip>
    </template>
    <template #item.taskStatus="{ item }">
      <v-chip color="grey-darken-3" density="compact" rounded="pill">
        <span class="font-weight-bold">{{
          item.task?.status?.name || '--- '
        }}</span>
      </v-chip>
    </template>
    <template #item.task="{ item }">
      <span
        v-if="item.task"
        v-tooltip:bottom="item.task.status.name"
        class="link"
        @click="
          $router.push({
            name: 'single-task',
            params: { id: item.task.id },
          })
        ">
        {{ item.task.topic }}
      </span>
      <span v-else>---</span>
    </template>
    <template #item.executor="{ item }">
      <span>
        {{ getPersonName(item.task?.executor) || '---' }}
      </span>
    </template>
    <template #item.actions="{ item }">
      <b-action-menu
        :actions="[
          {
            title: 'Проставити статус',
            icon: 'mdi-set-split',
            action: () => setRecommendationStatus(flawId, item.id),
            disabled: ![1, 5].includes(user?.roleId),
            iconProps: {
              color: 'blue-darken-3',
            },
          },
        ]"></b-action-menu>
    </template>
  </v-data-table>
</template>

<script lang="ts">
import { auditRecommendationListHeaders } from '@/utils/tableHeaders'
import { computed, PropType } from 'vue'
import { BActionMenu } from 'best-modules/components'
import { getPersonName } from 'best-modules/utils/helpers'
import { useStore } from '@/plugins'
import { useAudit } from '../../index'
import { AuditRecommendation } from '@/utils/types/audit'

export default {
  name: 'RecommendationList',
  components: { BActionMenu },
  props: {
    flawId: {
      type: Number,
    },
    recommendations: {
      type: Array as PropType<AuditRecommendation[]>,
    },
  },
  data: () => {
    return {
      auditRecommendationListHeaders,
    }
  },
  methods: { getPersonName },
  setup() {
    const store = useStore()
    const user = computed(() => store.state.user.userData)
    const { createRecommendation, setRecommendationStatus } = useAudit()

    return {
      createRecommendation,
      setRecommendationStatus,
      user,
    }
  },
}
</script>

<style lang="scss" scoped></style>
